module.exports = __webpack_public_path__ + "img/rep-question.87d3c06d.svg";